import { WalkActivity } from '../types/walk'

class ActivityService {
  private baseUrl = '/api/walk-activities'

  private getHeaders(includeAuth: boolean = false) {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    }
    
    if (includeAuth) {
      const adminToken = localStorage.getItem('adminToken')
      if (adminToken) {
        headers['Authorization'] = `Bearer ${adminToken}`
      }
    }
    
    return headers
  }

  async getWalkActivities(walkId: string): Promise<{ walk: { id: string, name: string, description: string, bounds: any }, activities: WalkActivity[] }> {
    const response = await fetch(`${this.baseUrl}?walkId=${walkId}`, {
      headers: this.getHeaders()
    })
    
    if (!response.ok) {
      throw new Error(`Failed to fetch activities: ${response.statusText}`)
    }
    
    return response.json()
  }

  async deleteActivity(activityId: number): Promise<void> {
    const response = await fetch(`/api/activity-delete`, {
      method: 'DELETE',
      headers: this.getHeaders(true),
      body: JSON.stringify({ activityId })
    })
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      throw new Error(error.details || error.error || `Failed to delete activity: ${response.statusText}`)
    }
  }

  async deleteActivityByStravaId(stravaActivityId: string): Promise<void> {
    const response = await fetch(`/api/activity-delete`, {
      method: 'DELETE',
      headers: this.getHeaders(true),
      body: JSON.stringify({ stravaActivityId })
    })
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      throw new Error(error.details || error.error || `Failed to delete activity: ${response.statusText}`)
    }
  }
}

export const activityService = new ActivityService()